module.exports = __webpack_public_path__ + "media/packs/src/assets/images/scheduling-06d07a76341f010e7da84f32e1352b3a.png";